import React from 'react';
import { observer } from 'mobx-react-lite';
import { TableCell, TextField, InputAdornment } from '@mui/material';
import { noop } from 'lodash';
import { Form } from 'mobx-react-form';

import { DraggableTableRow } from 'components/shared/DragDropTable';
import NumericInput from 'components/shared/inputs/NumericInput';

type SaleRowProps = {
  id: string;
  streetAddress: string;
  index: number;
  removeSale?: (index: number) => void;
  propertyIdentifier?: string;
  form: Form;
};

const SaleRow = observer(({ id, index, propertyIdentifier, removeSale = noop, streetAddress, form }: SaleRowProps) => {
  const prefix = `propertyHistory.salesHistory.${index}`;
  const uniqueSaleField = form.$(prefix + '.uniqueSaleId');
  const saleDateField = form.$(prefix + '.date');
  const salePriceField = form.$(prefix + '.price');
  const sellerField = form.$(prefix + '.seller');

  return (
    <DraggableTableRow id={id} index={index} onRemove={() => removeSale(index)}>
      <TableCell key="streetAddress">{streetAddress || '-'}</TableCell>
      <TableCell key="propertyIdentifier">{propertyIdentifier || 'N/A'}</TableCell>
      <TableCell key="uniqueSaleId">
        <TextField {...uniqueSaleField.bind()} size="small" margin="normal" placeholder="N/A" fullWidth />
      </TableCell>
      <TableCell key="saleDate">
        <TextField
          {...saleDateField.bind()}
          size="small"
          margin="normal"
          type="date"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            max: new Date().toISOString().split('T')[0],
          }}
        />
      </TableCell>
      <TableCell key="salePrice">
        <NumericInput
          {...salePriceField.bind()}
          size="small"
          margin="normal"
          fullWidth
          decimalScale={2}
          allowNegative={false}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
          placeholder="0.00"
          thousandSeparator
        />
      </TableCell>
      <TableCell key="seller">
        <TextField {...sellerField.bind()} size="small" margin="normal" placeholder="N/A" fullWidth />
      </TableCell>
    </DraggableTableRow>
  );
});

export default SaleRow;
